/* eslint-disable max-len */

import React, { Component } from 'react';
import axios from 'axios';
import { Button, Result } from 'antd';
import { Loading } from '@/components/Loading';
import { BACKEND_URL_ACCOUNT } from 'Config/routes';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';
import { env } from '@/shared/config/env';
import { ROUTES } from './Router/routes';

export class LoginMiddleware extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFeching: false,
      tokenIsValid: false,
      token: null,
      external_session: false,
      errorMessage: null,
    };
  }

  componentDidMount() {
    // Valide si el token es válido
    this.validateTokenAuth();
  }

  // eslint-disable-next-line class-methods-use-this
  getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const external = window.location.pathname.substring(1) === "external";

    if (!query) {
      return false;
    }

    const vars = query.split('&');

    let filteredValue = vars.find((pathVariable) => {
      const pair = pathVariable.split('=');
      return pair[0] === variable;
    });

    if (!filteredValue) return false;
    // eslint-disable-next-line prefer-destructuring
    filteredValue = filteredValue.split('=')[1];

    return [filteredValue, external];
  }

  validateTokenAuth() {
    // Obtiene el token de la URL o el Local storage
    const [token, external_session] = this.getQueryVariable('token') || [localStorage.getItem('token'), localStorage.getItem('external_session') === "true"];

    // Ramover el Token de la URL
    window.history.replaceState({}, document.title, window.location.pathname);

    this.setState({
      token,
      external_session,
    });

    // Si no hay token se retorna el error
    if (!token) {
      this.setState({
        tokenIsValid: false,
        errorMessage: 'Falta el token de autenticación.',
      });
      return;
    }

    // valida en el server si es válido
    this.validateToken(token, external_session);
  }

  // eslint-disable-next-line class-methods-use-this
  validateToken(validateToken, external_session) {
    const form = new FormData();
    form.append('token', validateToken);

    this.setState({
      isFeching: true,
    });
    var url = `${BACKEND_URL_ACCOUNT}token_validation/`;
    if (external_session) {
      url = `${BACKEND_URL_ACCOUNT}external_token_validation/`;
    }
    axios({
      method: 'POST',
      url: url,
      data: form,
      headers: {
        // eslint-disable-next-line no-underscore-dangle
        'content-type': `multipart/form-data; boundary=${form._boundary}`,
      },
    })
      .then((res) => {
        this.setState({
          tokenIsValid: !!res.data.isValid,
          isFeching: false,
        });
      })
      .catch((error) => {
        this.setState({
          isFeching: false,
          errorMessage: getErrorMessage(error),
        });
      });
  }

  render() {
    const { isFeching, tokenIsValid, token, external_session, errorMessage } = this.state;
    // eslint-disable-next-line react/prop-types
    const { children } = this.props;

    if (isFeching) {
      return <Loading loadingMessage='Validando autentificación' />;
    }

    if (!tokenIsValid) {
      // Para tokens externos se muestra un mensaje simple
      if (external_session) {
        return (
          <Result
            status='403'
            title='Enlace caducado'
            subTitle='El enlace que estás usando ha caducado. Solicita un nuevo enlace a tu asesor para poder acceder.'
          />
        );
      }

      // Se agrega un punto al final del mensaje de error si no lo tiene
      const finalErrorMessage = errorMessage
        ? `${errorMessage.trim()}${errorMessage.trim().endsWith('.') ? '' : '.'}`
        : 'Token no válido.';

      const isHome = window.location.pathname === ROUTES.HOME;

      const subTitle = isHome
        ? `${finalErrorMessage} Para continuar, abra la app del cotizador desde el menú de Softseguros.`
        : `${finalErrorMessage} Para continuar, abra la app del cotizador desde el menú de Softseguros y luego recargue esta página.`;

      return (
        <Result
          status='403'
          title='No se pudo completar la autenticación'
          subTitle={subTitle}
          extra={[
            <Button
              key='login'
              type='primary'
              href={env.URL_SOFTSEGUROS}
              target={isHome ? '_self' : '_blank'} // Mantener la navegación en la misma ventana para 'Home'; usar una nueva pestaña para otras rutas
              rel='noopener noreferrer'
            >
              Ir a Softseguros
            </Button>,
            !isHome && <Button key='reload' onClick={() => window.location.reload()}>
              Recargar página
            </Button>,
          ].filter(Boolean)}
        />
      );
    }

    // Guardar el token en el Local Storage
    localStorage.setItem('token', token);
    localStorage.setItem('external_session', external_session);

    return children;
  }
}